import { cn } from "@reactive-resume/utils";
import { cva, type VariantProps } from "class-variance-authority";

const pillVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium",
  {
    variants: {
      variant: {
        success: "border-emerald-200 bg-emerald-50 text-emerald-700",
        warning: "border-amber-200 bg-amber-50 text-amber-700",
        info: "border-sky-200 bg-sky-50 text-sky-700",
        error: "border-rose-200 bg-rose-50 text-rose-700",
        neutral: "border-border bg-muted text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  },
);

const dotVariants = cva("size-1.5 rounded-full", {
  variants: {
    variant: {
      success: "bg-emerald-500",
      warning: "bg-amber-500",
      info: "bg-sky-500",
      error: "bg-rose-500",
      neutral: "bg-muted-foreground",
    },
  },
  defaultVariants: {
    variant: "neutral",
  },
});

export type PillProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof pillVariants> & {
    dot?: boolean;
  };

export const Pill = ({ className, variant, dot = false, children, ...props }: PillProps) => (
  <span className={cn(pillVariants({ variant }), className)} {...props}>
    {dot ? (
      <span
        aria-hidden="true"
        className={cn(dotVariants({ variant }), variant === "success" && "animate-pulse")}
      />
    ) : null}
    {children}
  </span>
);
